import './last_digit';
import './last_digit_list';
import './digit_percentage';
import './even_odd_amount';
import './under_over_amount';
import './least_frequent_digit';
import './most_frequent_digit';
import './are_the_last_digits_the_same';
import './get_decimals';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/digits/index.js